export { default as MyPortfolios } from './component';
